import React from 'react';
import { PieChart, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-50 border-t border-slate-200 pt-16 pb-8" data-id="element-1">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-3">
          <div className="col-span-1 md:col-span-1" data-id="element-4">
            <div className="flex items-center gap-2 mb-4" data-id="element-5">
              <div className="bg-blue-600 p-1.5 rounded-lg" data-id="element-6">
                <PieChart className="h-5 w-5 text-white" data-id="element-7" />
              </div>
              <span className="text-lg font-bold tracking-tight text-slate-900" data-id="element-8">
                CreditArea
              </span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed mb-6" data-id="element-9">
              Simplificăm accesul la finanțare pentru companiile românești.
              Transparent, rapid și 100% digital.
            </p>
            <div className="flex gap-4" data-id="element-10">
              <a href="#" className="text-slate-400 hover:text-blue-600 transition-colors" aria-label="LinkedIn" data-id="element-11">
                <Linkedin className="h-5 w-5" data-id="element-12" />
              </a>
              <a href="#" className="text-slate-400 hover:text-green-600 transition-colors" aria-label="WhatsApp" data-id="element-13">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" data-id="element-14">
                  <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" data-id="element-15" />
                  <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" data-id="element-16" />
                </svg>
              </a>
            </div>
          </div>

          <div data-id="element-17">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-18">Produs</h4>
            <ul className="space-y-2 text-sm text-slate-600" data-id="element-19">
              <li data-id="element-20">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-21">
                  Credit IMM
                </a>
              </li>
              <li data-id="element-22">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-23">
                  Linii de credit
                </a>
              </li>
              <li data-id="element-24">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-25">
                  Factoring
                </a>
              </li>
              <li data-id="element-26">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-27">
                  Leasing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-28">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-29">Companie</h4>
            <ul className="space-y-2 text-sm text-slate-600" data-id="element-30">
              <li data-id="element-31">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-32">
                  Parteneri bancari
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-33">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-34">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-600" data-id="element-35">
              <li data-id="element-36">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-37">
                  Termeni
                </a>
              </li>
              <li data-id="element-38">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-39">
                  Confidențialitate
                </a>
              </li>
              <li data-id="element-40">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-41">
                  Cookie-uri
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-blue-600 transition-colors" data-id="element-43">
                  ANPC
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-44">
          <p className="text-sm text-slate-500" data-id="element-45">
            © 2025 CreditArea România. Toate drepturile rezervate.
          </p>
          <div className="flex items-center gap-2" data-id="element-46">
            <span className="h-2 w-2 rounded-full bg-emerald-500" data-id="element-47"></span>
            <span className="text-sm text-slate-600 font-medium" data-id="element-48">
              Sisteme operaționale
            </span>
          </div>
        </div>
      </div>
    </footer>;
}